import React from 'react';
import styled from 'styled-components';
import { blue300 } from '@prezi/common-design';
const HighlightedChunk = styled.span.withConfig({
  displayName: "highlight__HighlightedChunk",
  componentId: "aezeia-0"
})(["color:", ";"], blue300);
const highlight = (text, highlight) => {
  const i0 = text.toLowerCase().indexOf(highlight.toLowerCase());
  const iN = i0 + highlight.length;
  if (i0 === -1) {
    return text;
  }
  return React.createElement(React.Fragment, null, text.slice(0, i0), React.createElement(HighlightedChunk, null, text.slice(i0, iN)), text.slice(iN));
};
export default highlight;